import React, { Component } from 'react';
import { Grid, Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { ConsultaPaices, ConsultaEstadosSelect, ConsultaMunicipiosSelect, ConsultaParroquias, verParroquia, GuardarParroquia, DeleteParroquia, EditarParroquia } from "../../../funciones/EntidadesFuncion";

let statusBtn = 0;
let idParroquia = null;

class Parroquias extends Component {
    state = {
        textInfo: <React.Fragment>Para agregar una nueva parroquia indica primero el <strong>País, el Estado y el Municipio </strong> a tu izquierda</React.Fragment>,
        preloaderMess:{ icon: "", text: "" },
        valorPais: { value: '', label: '- Selecciona un País -' },
        valorEstado: { value: '', label: '- Selecciona un Estado -' },
        valorMunicipio: { value: '', label: '- Selecciona un Municipio -' },
        paices: [{ value: '', label: ' - Cargando Espere - ' }],
        estados: [{ value: '', label: ' - Selecciona un País - ' }],
        municipios: [{ value: '', label: ' - Selecciona un Estado - ' }],
        parroquiasDisp: [{ id: "", nombre: "" }],
        boton1: { Icon:"fa fa-save", Title:"Guardar", disabled: ""},
        boton2: { Icon:"fa fa-times", Title:"", disabled: ""},
        boton3: { Icon:"fa fa-edit", Title:"", disabled: ""},
        boton4: { Icon:"fa fa-trash", Title:"", disabled: ""},
        nombre:  { text:"", status: "" },
        cantErrores: "",
    }

    componentWillReceiveProps = (props) => {
        statusBtn = 0;
        this.setState({paices: props.paises})
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:(event.target.value).toUpperCase(),
                status: "",
            }
        });
    };

    valorSelectPais = (valorPais) => {
        this.setState({
            valorPais,
            preloader:{
                icon: "fa fa-spinner fa-spin",
                text: "Cargando"
            },
            textInfo: <React.Fragment>Has seleccionado <strong>{valorPais.label}</strong></React.Fragment>,
        },() => {
            ConsultaEstadosSelect(valorPais.value, (resp) => {
                this.setState({
                    estados: resp,
                    preloader:{ icon: "", text: "" },
                })
            })
        });
    }

    valorSelectEstado = (valorEstado) => {
        this.setState({
            valorEstado,
            preloader:{
                icon: "fa fa-spinner fa-spin",
                text: "Cargando"
            },
            textInfo: <React.Fragment>
                        <div>
                            Has seleccionado <strong>{this.state.valorPais.label}</strong>
                        </div>
                        <div>
                            Estado: <strong>{valorEstado.label}</strong>
                        </div>
                    </React.Fragment>,
        },() => {
            ConsultaMunicipiosSelect(valorEstado.value, (resp) => {
                this.setState({
                    municipios: resp,
                    preloader:{ icon: "", text: "" },
                })
            })
        });
        
    }

    valorSelectMunicipio = (valorMunicipio) => {
        if (this.state.valorPais.value === "") return null;
        if (this.state.valorEstado.value === "") return null;

        this.setState({
            valorMunicipio,
            preloader:{
                icon: "fa fa-spinner fa-spin",
                text: "Cargando"
            },
            textInfo: <React.Fragment>
                        <div>
                            Has seleccionado <strong>{this.state.valorPais.label}</strong>
                        </div>
                        <div>
                            Estado: <strong>{this.state.valorEstado.label}</strong> | Municipio: <strong>{valorMunicipio.label}</strong>
                        </div>
                    </React.Fragment>,
        },() => {
            ConsultaParroquias(valorMunicipio.value, (resp) => {
                this.setState({
                    parroquiasDisp: resp,
                    preloader:{ icon: "", text: "" },
                })
            })
        });
    }

    cintillo = () => {
        let { valorPais, valorEstado, paices, estados, valorMunicipio, municipios } = this.state;

        let MainAyuda = (
            <Popover title="Registro de Ciudades" id="pais">
                <div align="justify">
                    Para registrar parroquias primero selecciona el país, el estado y el municipio  al que pertenece e ingresa el nombre de la ciudad y a continuación presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth:1}}><i className="fa fa-save"></i> Guardar</button>
                </div>
                <div align="justify" className="custom-mt-10">
                    Para modificar una parroquia primero haz click en uno de los agregados a tu izquierda
                </div>
                <div align="justify" style={{fontSize:10}} className="custom-mt-10">
                    El botón <button className="btn btn-primary btn-xs" style={{borderWidth:1}}><i className="fa fa-times"></i></button> Permite cancelar la selección
                </div>
                <div align="justify" style={{fontSize:10, marginTop: 5}}>
                    El botón <button className="btn btn-warning btn-xs" style={{borderWidth:1}}><i className="fa fa-edit"></i></button> Permite guardar los cambios
                </div>
                <div align="justify" style={{fontSize:10, marginTop: 5}}>
                    El botón <button className="btn btn-danger btn-xs" style={{borderWidth:1}}><i className="fa fa-trash"></i></button> Permite eliminar el pais seleccionado
                </div>
            </Popover>
        )

        return (
            <div className="custom-alert-success">
                <Row>
                    <Col md={3}>
                        <Select
                            isSearchable ={true}
                            value={valorPais}
                            onChange={this.valorSelectPais}
                            options={paices}
                        />
                    </Col>
                    <Col md={3}>
                        <Select
                            isSearchable ={true}
                            value={valorEstado}
                            onChange={this.valorSelectEstado}
                            options={estados}
                        />
                    </Col>
                    <Col md={3}>
                        <Select
                            isSearchable ={true}
                            value={valorMunicipio}
                            onChange={this.valorSelectMunicipio}
                            options={municipios}
                        />
                    </Col>
                    <Col md={3} align="right">
                        <OverlayTrigger trigger="focus" placement="left" overlay={ MainAyuda }>
                            <button className="btn btn-relleno-success" style={{borderWidth:1, marginTop: 3}} title="Ayuda"><i className="fa fa-question-circle-o"></i></button>
                        </OverlayTrigger>
                    </Col>
                </Row>
            </div>
        )
    }

    cancelar = () => {
        statusBtn = 0;
        this.setState({
            nombre:  { text:"", status: "" },
            cantErrores: "",
        })
    }

    editParroquia = (id) => (e) => {
        idParroquia = id;
        statusBtn = 1;
        this.setState ({
            preloaderMess:{ icon: "fa fa-spinner fa-spin", text: "" },
            boton2: { Icon:"fa fa-times", Title:"", disabled: "disabled"},
            boton3: { Icon:"fa fa-edit", Title:"", disabled: "disabled"},
            boton4: { Icon:"fa fa-trash", Title:"", disabled: "disabled"},
        }, () => {
            verParroquia (id, (resp) => {
                this.setState(resp)
            })
        })
    }

    parroquiasDisp = () => {
        let { parroquiasDisp } = this.state;

        if (parroquiasDisp[0] === undefined) return (
            <div style={{fontSize:12, paddingTop:15}} align="center">
                No existen ciudades disponibles
            </div> 
        )

        if (parroquiasDisp[0].id === "") return (
            <div style={{fontSize:12, paddingTop:15}} align="center">
                Primero selecciona un <strong>País, un Estado y un Municipio</strong> para mostrar las parroquias disponibles
            </div> 
        )

        let contenido = () => {
            return(
                parroquiasDisp.map(option => (
                    <tr onClick = {this.editParroquia (option.id)} key={option.id} style={{cursor: "pointer"}} title = {`Haz Click para editar ${option.nombre}`}>
                        <td>{option.nombre}</td>
                    </tr>
                ))
            )
        }

        return (
            <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                <Table striped hover>
                    <tbody>
                        {contenido()}
                    </tbody>
                </Table>
            </div>
        );
    }

    panel = () => {
        return (
            <div className="custom-alert-info custom-mt-10" style={{padding: 10}}>
                <div style={{ overflowY :"auto", height:"32vh",}}>
                    {this.parroquiasDisp()}
                </div>
            </div>
        )
    }

    respuestaGuardar = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];

        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let messOk = (mensaje) => {
            let { valorMunicipio } = this.state;
            
            if (valorMunicipio.value !== "") ConsultaParroquias(valorMunicipio.value, (resp) => {
                this.setState({
                    parroquiasDisp: resp,
                    preloader:{ icon: "", text: "" },
                })
            })

            this.setState({
                boton1:{
                    Icon:"fa fa-save",
                    Title:"Guardar",
                },
                boton3:{ Icon:"fa fa-edit" }
            }, () => {
                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) {
            this.cancelar()
            this.setState({ cantErrores:"" })
        }
        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        messOk(mensaje[0]);
    }

    respuestaEditar = (resp) => {
        this.respuestaGuardar(resp)
    }
    
    botones = () => {
        let { valorPais, valorEstado, valorMunicipio, nombre, boton1, boton2, boton3, boton4 } = this.state;
        const campos = { nombre, valorPais, valorEstado, valorMunicipio }

        switch (statusBtn) {
            case 0:
                return (
                    <button className="btn btn-primary" disabled={boton1.disabled} style={{borderWidth: 1}} onClick={ (e) => {
                        this.setState({
                            boton1:{ Icon: "fa fa-spinner fa-spin", Title: "Cargando" }
                        }, () => {
                            GuardarParroquia (campos, (resp) => { this.respuestaGuardar(resp) })
                        })
                    }}><i className={boton1.Icon}></i> {boton1.Title}</button>
                )
            case 1:

                let deleteC = (
                    <Popover title="Confirmacion" id="delpais">
                        <div>
                            ¿Desea realmente <strong>eliminar la parroquia <span className="text-info">{nombre.text}</span></strong> del Sistema?
                        </div>
                        <div align="right">
                            <button className="btn btn-danger" onClick = {

                                () => { DeleteParroquia(idParroquia, (mess) => {
                                    let data = JSON.parse(mess);
                                    if (data.status === "Error"){
                                        toast.error(data.mess,{autoClose: 4000});
                                        this.cancelar()
                                    }else{
                                        if (valorEstado.value !== "" && valorMunicipio.value !== "") ConsultaParroquias(valorMunicipio.value, (resp) => {
                                            this.setState({
                                                parroquiasDisp: resp,
                                                preloader:{ icon: "", text: "" },
                                            })
                                        })

                                        toast.info("La parroquia fue eliminado exisosamente",{autoClose: 4000});
                                        this.cancelar()
                                    }
                                })}

                            } style={{borderWidth: 1}}><i className="fa fa-trash"></i> Eliminar</button>
                        </div>
                    </Popover>
                )
                    
                return (
                    <div className="btn-group" role="group">
                        <button className="btn btn-primary"  disabled={boton2.disabled} onClick ={this.cancelar} title="Cancelar" style={{borderWidth: 1}}><i className={boton2.Icon}></i></button>
                        <button className="btn btn-warning"  disabled={boton3.disabled}
                        onClick={ (e) => {
                            this.setState({
                                boton3:{ Icon: "fa fa-spinner fa-spin" },
                            }, () => {
                                EditarParroquia (idParroquia, campos, (resp) => { this.respuestaEditar(resp) })
                            })
                        }}
                        title="Editar esta Parroquia" style={{borderWidth: 1}}><i className={boton3.Icon}></i></button>
                        <OverlayTrigger trigger="click" placement="top" overlay={deleteC}>
                            <button className="btn btn-danger" disabled={boton4.disabled} title="Eliminar esta Parroquia" style={{borderWidth: 1}}><i className={boton4.Icon}></i></button>
                        </OverlayTrigger>
                    </div>
                )
            default:
                return (<div></div>)
        }
    }

    registro = () => {
        let { nombre, cantErrores, preloaderMess, textInfo } = this.state;
        return (
            <Row className="custom-mt-20">
                <Col md={12} style={{paddingTop: 8}}>
                    <div style={{fontSize: 12, marginTop: -4}} className="custom-color">{textInfo}</div>
                </Col>
                <Col md={8} className="custom-mt-10">
                    <div className={nombre.status}>
                        <input type="text" value={nombre.text} onChange={this.cambiaValor("nombre")} className="form-control" placeholder="* Nombre de la Parroquia"/>
                    </div>
                </Col>
                <Col md={4} align="right">
                    {this.botones()}
                </Col>
                <Col md ={12}><div className="text-danger">{ cantErrores }</div></Col>
                <Col md ={12} align="center"><span><i className={preloaderMess.icon}></i>{preloaderMess.text}</span></Col>
            </Row>
        )
    }

    render() { 
        return (
            <Grid fluid className="custom-mt-20">
                <Row>
                    <Col md={12}>{this.cintillo()}</Col>
                    <Col md={4}>{this.panel()}</Col>
                    <Col md={8}>{this.registro()}</Col>
                </Row>
            </Grid>
        );
    }
}
 
export default Parroquias;


// WEBPACK FOOTER //
// ./src/views/Registros/EstadosContent/Parroquias.jsx